import { render, staticRenderFns } from "./FSEditor.vue?vue&type=template&id=8b3e4dd0&"
import script from "./FSEditor.vue?vue&type=script&lang=js&"
export * from "./FSEditor.vue?vue&type=script&lang=js&"
import style0 from "./FSEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports